import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

const StatusBanner = styled(Typography)(() => ({
	[`&.SENT_OK`]: {
		backgroundColor: "#98bd0a",
		color: "#333",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.ERROR`]: {
		backgroundColor: "#D32F2F",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.DRAFT`]: {
		backgroundColor: "#e8c600",
		color: "#222",
		padding: "0 4px",
		marginBottom: "0",
		fontWeight: "600",
	},
	[`&.ACQUIRED`]: {
		backgroundColor: "#007a4d",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.REJECTED`]: {
		backgroundColor: "#c82269",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.CLOSED`]: {
		backgroundColor: "#464646",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.SENT_KO`]: {
		backgroundColor: "#c82269",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.INTERMEDIATE_APPROVED`]: {
		backgroundColor: "#893de7",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.CORPORATE_VERIFIED`]: {
		backgroundColor: "#893de7",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.BANK_CORPORATE_VERIFIED_1`]: {
		backgroundColor: "#5258e4",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.BANK_CORPORATE_VERIFIED_2`]: {
		backgroundColor: "#5258e4",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.BANK_CORPORATE_AUTHORIZER_VERIFIED`]: {
		backgroundColor: "#6b48e5",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.BANK_AUTHORIZER_VERIFIED`]: {
		backgroundColor: "#0265dc",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.BANK_AUTHORIZER_VERIFIED_2`]: {
		backgroundColor: "#00719f",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.BANK_AUTHORIZER_VERIFIED_1`]: {
		backgroundColor: "#0168be",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.BANK_VERIFIED`]: {
		backgroundColor: "#27bb36",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.FINAL_APPROVED`]: {
		backgroundColor: "#007772",
		color: "#FFF",
		padding: "0 4px",
		marginBottom: "0",
	},
	[`&.NOT_ACQUIRED`]: {
		backgroundColor: "#f68511",
		color: "#333",
		padding: "0 4px",
		marginBottom: "0",
	},
}))

const Status = ({ status }: { status: string }) => {
	return (
		<StatusBanner className={`title ${status}`} variant="overline">
			{status}
		</StatusBanner>
	)
}

export default Status
